import { ZmenaStadia, ZmenaStadiaApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import ZmenaStadiaRequest from '../../model/admin/ZmenaStadiaRequest';

const client = new ZmenaStadiaApi(apiConfiguration(elegislativaPrefixPath));

const map = (request: ZmenaStadiaRequest): ZmenaStadia => ({
  stadium: request.stadium,
  typMaterialuKod: request.typMaterialuKod,
  skipServiceTasks: request.skipServiceTasks,
});

// eslint-disable-next-line import/prefer-default-export
export const changeMaterialStadium = async (
  type: string,
  year: number,
  index: number,
  request: ZmenaStadiaRequest,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.changeMaterialStadium(type, year, index, map(request), headers);
  return {
    responseCode: status,
  };
};
